import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { SuperAdminGuard } from "../guards/super-admin.guard";

export const TenantPipelineRoutes: Route[] = [
  {
    path: "tenant-pipeline",
    loadComponent: () =>
      import("../../Feature/tenant-pipeline/pages/pipeline/tenant-pipeline.component").then(
        (mod) => mod.TenantPipelineComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: "tenant-pipeline/new",
    loadComponent: () =>
      import("../../Feature/tenant-pipeline/pages/new/tenant-new.component").then((mod) => mod.TenantNewComponent),
    pathMatch: "full",
    canActivate: [AuthGuard, SuperAdminGuard],
  },
];
